import { NeedsAnalysisEligibility } from '@general/js/enums';

/**
 * Checks whether show the Veteran Card section or no.
 *
 * @param {boolean} isDependant - If member is dependant.
 * @param {string} eligibility - type of eligibility.
 * @return {boolean} - True if met condition to show Veteran Card section, or false otherwise.
 */
export const showVeteranCardSection = (isDependant, eligibility) => {
  return (
    !isDependant &&
    eligibility &&
    (eligibility.toLowerCase() === NeedsAnalysisEligibility.SERVING.toLowerCase() || eligibility.toLowerCase() === NeedsAnalysisEligibility.EX_SERVING.toLowerCase())
  );
};
